"use client";

import { ArticleCategory } from "@/sanity/sanity.types";
import GridColumn from "../common/grid-column/grid-column";
import GridRow from "../common/grid-row/grid-row";
import SuperTitle from "../common/supertitle/supertitle";
import css from "./resources.module.scss";
import { ArticleData, ResourcesPageData } from "@/sanity/interfaces";
import ResourcesArticleBlockAuto from "./resources-article-block/resources-article-block-auto";
import useBreakpoint from "@/hooks/useBreakpoint";
import { usePerformance } from "@/contexts/performance-context";
import { useEffect } from "react";
import { ImageLoading } from "@/utilities/imageLoading";

interface IResourcesProps {
  data: ResourcesPageData;
  articleData: {
    category: ArticleCategory;
    articles: ArticleData[];
  }[];
  beforeQueryTime: number;
  afterQueryTime: number;
}

const ResourcesAuto = (props: IResourcesProps) => {
  const {
    data,
    articleData: sections,
    beforeQueryTime,
    afterQueryTime,
  } = props;
  const { eyebrow, label, subheading } = data;
  const { checkTimeElapsed } = usePerformance();
  const { lg } = useBreakpoint();

  const formatHighlight = (text: string) => {
    const keyword = "and improving your financial well-being.";
    if (lg && text.includes(keyword)) {
      const [before] = text.split(keyword);
      return (
        <>
          {before}
          <br />
          {keyword}
        </>
      );
    }
    return text;
  };

  useEffect(() => {
    checkTimeElapsed(beforeQueryTime, "Resources page before query started");
    checkTimeElapsed(afterQueryTime, "Resources page after query completed");
  }, []);

  return (
    <div className={`${css.resources} gap-8`}>
      <GridRow>
        <GridColumn center className={css.resourcesHeader}>
          <div className="m-auto flex max-w-3xl flex-col gap-1 text-center">
            {eyebrow && (
              <SuperTitle className={css.resourcesSuperTitle}>
                {eyebrow}
              </SuperTitle>
            )}
            <h1>{label}</h1>

            {subheading && (
              <p className="text-base md:text-[18px] md:leading-[26px]">
                {formatHighlight(subheading)}
              </p>
            )}
          </div>
        </GridColumn>
      </GridRow>
      {sections &&
        sections.map((section, index) => (
          <ResourcesArticleBlockAuto
            key={index}
            reverse={index % 2 === 1 && lg}
            category={section.category}
            articles={section.articles}
            imageLoading={index === 0 ? ImageLoading.EAGER : ImageLoading.LAZY}
          />
        ))}
    </div>
  );
};

export default ResourcesAuto;
